module.exports = __webpack_public_path__ + "img/size5_en.a0980ec2.png";